import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import { reactIcons } from "../utils/icons";
import CustomNoRowsOverlay from "../utils/styles";
import * as api from "../redux/api";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const ReportStepOne = () => {
  const navigate = useNavigate();
  const { nodeId, date } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [typeOfNodeId, setTypeOfNodeId] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 8
  });
  const [rowCountState, setRowCountState] = useState(0);

  const [rows, setRows] = useState([]);

  const columns = [
    {
      field: "_id",
      headerName: "S.No.",
      type: "number",
      headerAlign: "left",
      align: "Left",
      width: 250
    },
    {
      field: "node_id",
      headerName: "Node ID",
      type: "string",
      flex: 3
    },
    {
      field: "validated_block_time",
      headerName: "Block Validated Time",
      type: "string",
      headerAlign: "center",
      align: "center",
      flex: 3
    },
    {
      field: "block_id",
      headerName: "Block ID",
      type: "string",
      headerAlign: "center",
      align: "center",
      flex: 3
    },
    {
      field: "trans_hash",
      headerName: "Transaction Hash",
      type: "string",
      headerAlign: "center",
      align: "center",
      flex: 3
    }
  ];
  const getReportDetails = async () => {
    setIsLoading(true);
    const response = await api.getReportListDetails(
      typeOfNodeId !== "" ? typeOfNodeId : nodeId,
      date,
      paginationModel.page
    );

    const { status, data } = response;
    if (status >= 200 && status < 300) {
      setIsLoading(false);
      setRowCountState(Number(data.count));
      setRows(
        data.data.map((item, index) => {
          return {
            ...item,
            _id: 8 * paginationModel.page + index + 1,
            node_id: item.validatorNodeId,
            validated_block_time: moment(item.timestamp).format("hh:mm:ss a"),
            block_id: item.blockNumber,
            trans_hash: item.txHash || "N/A"
          };
        })
      );
    } else {
      setIsLoading(false);
      toast.error(data.message);
    }
  };
  useEffect(() => {
    try {
      getReportDetails();
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }

    setRowCountState((prevRowCountState) =>
      rowCountState !== undefined ? rowCountState : prevRowCountState
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel, rowCountState, setRowCountState, nodeId, typeOfNodeId]);
  return (
    <div className="w-full mt-6 data-grid">
      <div className="flex gap-2 mb-6 items-center justify-between">
        <div className="flex items-center gap-1">
          <button
            className="w-10 h-10 flex-center bg-green-600 rounded-full text-3xl"
            onClick={() => navigate(-1)}
          >
            {" "}
            {reactIcons.arrowleft}
          </button>
          <h4>Reports</h4>
        </div>
        <div className="form-select-custom w-[200px] hidden">
          <select
            className="min-w-[200px] max-w-[200px] w-full h-[40px] border border-black"
            name="typeOfOrder"
            id="typeOfOrder"
            value={typeOfNodeId}
            onChange={(e) => setTypeOfNodeId(e.target.value)}
          >
            {[
              { label: "Node ID", value: "" },
              { label: "1", value: "1" },
              { label: "2", value: "2" }
            ].map((item, index) => (
              <option key={index} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <span className="ay-center right-2 text-zinc-500 text-[20px] pointer-events-none ">
            {reactIcons.arrowDown}
          </span>
        </div>
      </div>

      <div className=" h-[600px] w-full">
        <DataGrid
          loading={isLoading}
          rows={rows}
          getEstimatedRowHeight={() => 52}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 8
              }
            }
          }}
          rowCount={rowCountState}
          pageSizeOptions={[8]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          slots={{
            loadingOverlay: LinearProgress,
            noRowsOverlay: CustomNoRowsOverlay
          }}
          disableColumnMenu
          disableRowSelectionOnClick
        />
      </div>
    </div>
  );
};

export default ReportStepOne;
